module.exports = __webpack_public_path__ + "static/media/b1_p13_clickable_b.c4c95475.png";